// extracted by mini-css-extract-plugin
module.exports = {"swap_banner_wrap":"SwapBanner_swap_banner_wrap__e3t5e","left_side":"SwapBanner_left_side__nuxOG","description":"SwapBanner_description__5pKz6","button":"SwapBanner_button__HcVM7"};